import React, { useEffect, useState } from 'react'

import PersonalInfoForm from '../components/profile/PersonalInfoForm'
import { EditFarmerInfoScreenProps } from '../routes/types'
import { FarmerDetails } from '../models/farmer'
import fetchFarmerDetails from '../apis/fetchFarmerDetails'
import { Spinner } from '@dehaat/dds'

const EditFarmerInfo = ({ route }: EditFarmerInfoScreenProps) => {
  const { farmerId } = route.params
  const [info, setInfo] = useState<FarmerDetails>()
  const [isLoading, setLoading] = useState(true)

  const fetchAndSetFarmerInfo = async () => {
    const response = await fetchFarmerDetails(farmerId)
    if (response) {
      setInfo(response)
    }
  }

  useEffect(() => {
    fetchAndSetFarmerInfo().finally(() => setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : info ? (
        <PersonalInfoForm
          farmerId={farmerId}
          phoneNumber={info.phone_number}
          name={info.full_name}
          age={info.profile.age}
          isSmartPhoneOwner={info.profile.smartphone_user ?? undefined}
          gender={info.profile.gender}
          address={info.address}
          landAreaUnit={info.profile.total_leased_land_unit}
          farmingArea={info.profile.total_leased_land}
          isDairyFarm={info.profile.dairy_farmer ?? undefined}
        />
      ) : null}
    </>
  )
}

export default EditFarmerInfo
